import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { FC } from 'react'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'

interface MergedStoreCategoryProductsTopBannerProps {
  bannerTitle: string | null
  bannerDescription: string | null
  bannerImageUrls: (string | null)[]
  isTemplate?: boolean
}

export const MergedStoreCategoryProductsTopBanner: FC<
  MergedStoreCategoryProductsTopBannerProps
> = ({ bannerTitle, bannerDescription, bannerImageUrls, isTemplate }) => {
  const [bannerImage, bannerImageTablet, bannerImageMobile] = bannerImageUrls
  const mobileBanner = isTemplate ? 'unset' : `url(${bannerImageMobile})`
  return (
    <Box
      backgroundImage={{
        _: mobileBanner,
        md: `url(${bannerImageTablet})`,
        lg: `url(${bannerImage})`
      }}
      backgroundPosition="center"
      backgroundSize={'cover'}
      backgroundRepeat="no-repeat"
      backgroundColor={isTemplate ? '#F4F0E9' : 'unset'}
      height={
        isTemplate
          ? { _: 'auto', md: '190px', lg: '255px' }
          : { _: '454px', md: '188px', lg: '268px', xl: '335px' }
      }
      position="relative"
      justifyContent={{ _: 'center', md: 'initial' }}
      data-testid="top-banner"
    >
      <Spacer ml={{ _: 0, md: '42px', lg: '64px', xl: '74px' }} />
      <Box flexDirection={'column'} maxWidth={{ _: '380px', md: '340px', lg: '600px' }}>
        <Spacer
          mt={
            isTemplate
              ? { _: '33px', md: '38px', lg: '68px', xl: '61px' }
              : { _: '44px', md: '55px', lg: '90px', xl: '104px' }
          }
        />
        <Text
          fontSize={{ _: '24px', lg: '28px', xl: '42px' }}
          lineHeight={{ _: '28px', lg: '36px', xl: '56px' }}
          fontWeight={600}
          textAlign={{ _: 'center', md: 'left' }}
          padding={{ _: '0 15px', md: 0 }}
          as="h1"
        >
          {bannerTitle}
        </Text>
        <Spacer mb="12px" />
        <Text
          variant={{ _: 'body/small', lg: 'body/medium' }}
          textAlign={{ _: 'center', md: 'left' }}
          padding={{ _: '0 15px', md: 0 }}
          maxWidth={{ _: '100%', md: '290px', lg: '480px' }}
        >
          {bannerDescription}
        </Text>
        <Spacer mb={isTemplate ? '40px' : 0} />
      </Box>
    </Box>
  )
}
